import styled from 'styled-components';

const StyledSidebarMenuIconContent = styled.img`
  width: 25px;
  height: 25px;
`;

export default StyledSidebarMenuIconContent;
